import { HOME_ROUTE } from './router/constants';
import { getInitialRoute } from './router/util';

export default [
  {
    path: '/',
    name: 'home',
    redirect: getInitialRoute,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: HOME_ROUTE },
    meta: {
      public: true,
    },
  },
];
